import React, { useEffect } from 'react'

import { STORAGE_KEY, setSettings, parseSettings, useSettings  } from '../slices/settings'

const SettingsManager = (props) => {
  const { zoom } = useSettings()

  useEffect(()=>{
    const storageHandler = (e) => {
      if (e.key === STORAGE_KEY){
        setSettings(parseSettings(e.newValue))
      }
    }
    window.addEventListener('storage', storageHandler )
    return () => window.removeEventListener('storage', storageHandler)
  }, [])

  useEffect(()=>{
    document.body.style.fontSize = `${zoom}em`
  }, [zoom])

  return null

}

export default SettingsManager
